import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'
import toast from 'react-hot-toast'
import { useCurrentUser } from './useCurrentUser'

const API_URL = import.meta.env.VITE_EPC_API_URL ?? ''

export const useBlockMatch = () => {
  const fetchWithAuth = useFetchWithAuth()
  const queryClient = useQueryClient()
  const { data: userData } = useCurrentUser()
  const userId = userData?.userId || ''

  return useMutation({
    mutationFn: async (targetProfileId: string) => {
      if (!userId) {
        throw new Error('User ID is required to toggle block status')
      }

      const response = await fetchWithAuth(
        `${API_URL}/profile/${userId}/block/${targetProfileId}`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
        }
      )
      return response
    },
    onSuccess: (data, targetProfileId) => {
      // Invalidate related queries
      queryClient.invalidateQueries({
        queryKey: ['profile', targetProfileId],
      })
      queryClient.invalidateQueries({
        queryKey: ['matchListData'],
      })

      toast.success(
        data?.blocked ? 'Removed from matches' : 'Added back to matches'
      )
    },
    onError: (error) => {
      console.error('Error toggling block status:', error)
      toast.error('Failed to update match status')
    },
  })
}
